<template>
    <div
        v-if="section === 'activation-modal'"
        :id="`plan-${plan.id}`"
        :class="`bg-white border border-${getColor()}-500 rounded-lg flex flex-col justify-between transform transition duration-300 ease-in-out h-full p-6`"
    >
        <div>
            <span
                v-if="plan.id == 'anual'"
                class="inline-flex items-center px-2 rounded bg-red-600 text-white text-sm absolute top-0 -mt-3 transform -translate-x-1/2 left-1/2"
                >Tu mejor opción</span
            >
            <p id="plan-name" class="text-gray-600 font-semibold">{{ plan.presentable_name }}</p>
            <div class="flex items-baseline mt-3">
                <h2 id="plan-pricing" class="md:text-4xl leading-none font-semibold">
                    {{ plan.presentable_pricing }}
                </h2>
                <span id="plan-currency" class="leading-none text-2xl font-semibold ml-2">
                    {{ plan.currency }}
                </span>
            </div>
            <h6 id="plan-description" class="md:text-base text-sm mt-1 md:h-12 sm:h-10 overflow-hidden mb-5">
                {{ plan.description }}
            </h6>
            <div id="plan-features" :class="`benefits-list benefits-list-${getColor()}`" v-html="plan.features"></div>
        </div>
        <label :id="`${plan.id}-modal-buttons`" class="flex items-center space-x-4 mt-3 mb-8 cursor-pointer">
            <input
                :id="`plan-link-${plan.id}`"
                :type="`radio`"
                :name="`plan-link`"
                :class="`appearance-none h-5 w-5 border border-gray-200 bg-gray-100 rounded-full checked:bg-red-500 focus:outline-none checked:border-4 checked:border-gray-100`"
                @click="choose"
            >
            </input>
            <span>
                {{ buttonText }}
            </span>
        </label>
        <div 
            :class="`bg-${getColor()}-500 rounded-b-md w-full absolute left-0 bottom-0 py-2`"
        >
            <p class="text-white text-xs text-center">Fecha del primer cobro: {{ plan.presentable_trial_ends_at }}</p>
        </div>
    </div>
    <div
        v-else-if="section === 'register-modal'"
        :id="`plan-${plan.id}`"
        :class="`bg-white border border-${getColor()}-500 rounded-lg flex flex-col justify-between transform transition duration-300 ease-in-out h-full p-6`"
    >
        <div>
            <span
                v-if="plan.id == 'anual'"
                class="inline-flex items-center px-2 rounded bg-red-600 text-white text-sm absolute top-0 -mt-3 transform -translate-x-1/2 left-1/2"
                >Tu mejor opción</span
            >
            <p id="plan-name" class="text-gray-600 font-semibold">{{ plan.presentable_name }}</p>
            <div class="flex items-baseline mt-3">
                <h2 id="plan-pricing" class="md:text-4xl leading-none font-semibold">
                    {{ plan.presentable_pricing }}
                </h2>
                <span id="plan-currency" class="leading-none text-2xl font-semibold ml-2">
                    {{ plan.currency }}
                </span>
            </div>
            <h6 id="plan-description" class="md:text-base text-sm mt-1 md:h-12 sm:h-10 overflow-hidden mb-5">
                {{ plan.description }}
            </h6>
            <div id="plan-features" :class="`benefits-list benefits-list-${getColor()}`" v-html="plan.features"></div>
        </div>
        <div :id="`${plan.id}-modal-buttons`">
            <span
                :id="`plan-link-${plan.id}`"
                :class="`btn btn-${getColor()} block w-full px-6 py-3 mt-1 disabled`"
            >
                {{ buttonText }}
            </span>
        </div>
    </div>
    <div
        v-else-if="section === 'home'"
        :id="`plan-${plan.id}`"
        :class="`bg-white border-2 ${
            this.getColor() == 'red' ? 'border-red-600' : 'border-blue-500'
        } rounded-lg flex flex-col justify-between relative transform transition duration-300 ease-in-out h-full p-8`"
    >
        <div>
            <span
                v-if="plan.id == 'anual'"
                class="inline-flex items-center px-2 rounded bg-red-600 text-white text-sm absolute top-0 -mt-3 transform -translate-x-1/2 left-1/2"
                >Tu mejor opción</span
            >
            <p id="plan-name" class="text-gray-600 font-semibold text-center text-lg">{{ plan.presentable_name }}</p>
            <div class="flex items-baseline justify-center mt-3">
                <h2 id="plan-pricing" class="md:text-5xl leading-none font-semibold">
                    {{ plan.presentable_pricing }}
                </h2>
                <span id="plan-currency" class="leading-none text-3xl font-semibold ml-2">
                    {{ plan.currency }}
                </span>
            </div>
            <h6
                id="plan-description"
                class="md:text-base text-sm text-center mt-1 md:max-h-12 sm:max-h-10 overflow-hidden mb-5"
            >
                {{ plan.description }}
            </h6>
            <div id="plan-features" :class="`benefits-list benefits-list-${getColor()}`" v-html="plan.features"></div>
        </div>
        <div :id="`home-plan-buttons-${plan.id}`">
            <span
                :id="`home-link-${plan.id}`"
                :class="`btn btn-${getColor()} block w-full px-6 py-3 mt-6 disabled`"
            >
                Comenzar
            </span>
            <p class="text-sm text-center mt-4">
                Fin de la prueba: <strong>{{ plan.presentable_trial_ends_at }}</strong>
            </p>
        </div>
        <div class="plan-stars absolute bottom-0 left-0 right-0 top-0 z-negative">
            <svg
                class="text-yellow-400 absolute transform z-negative"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 41.9 40.3"
            >
                <g>
                    <path
                        fill="currentColor"
                        d="M20.9 0c.5 0 .9.3 1 .7 1.6 3.6 3.2 7.2 4.8 10.7.2.5.4.9.6 1.4 0 .1.2.2.3.2 2.3.2 4.6.5 6.9.7 2.1.2 4.3.5 6.4.7.4 0 .8.3.9.7.1.4 0 .9-.3 1.1-.9.8-1.8 1.7-2.7 2.5l-7.2 6.6c-.1.1-.1.2-.1.3.9 4.3 1.8 8.6 2.7 12.8.1.2.1.5.1.7-.1.6-.6 1-1.1 1-.2 0-.3-.1-.5-.2-1-.6-1.9-1.1-2.9-1.7-2.9-1.7-5.8-3.3-8.6-5-.1-.1-.3-.1-.4 0-3.6 2.1-7.2 4.2-10.7 6.3-.3.2-.5.3-.8.5-.5.3-1.1.1-1.4-.3-.1-.2-.2-.5-.1-.8.4-2.1.9-4.3 1.3-6.4.5-2.3.9-4.5 1.4-6.8 0-.1 0-.3-.1-.4-2.3-2-4.5-4.1-6.8-6.1-1-.9-2.1-1.9-3.1-2.8-.4-.3-.5-.7-.4-1.2.1-.4.5-.7 1-.8 1.7-.2 3.3-.4 5-.5 2-.2 3.9-.4 5.9-.7.7-.1 1.5-.2 2.3-.2.2 0 .3-.1.4-.3 1.8-4 3.5-8.1 5.3-12.1 0-.3.4-.6.9-.6z"
                    />
                </g>
            </svg>
            <svg
                class="text-yellow-400 absolute transform z-negative"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 41.9 40.3"
            >
                <g>
                    <path
                        fill="currentColor"
                        d="M20.9 0c.5 0 .9.3 1 .7 1.6 3.6 3.2 7.2 4.8 10.7.2.5.4.9.6 1.4 0 .1.2.2.3.2 2.3.2 4.6.5 6.9.7 2.1.2 4.3.5 6.4.7.4 0 .8.3.9.7.1.4 0 .9-.3 1.1-.9.8-1.8 1.7-2.7 2.5l-7.2 6.6c-.1.1-.1.2-.1.3.9 4.3 1.8 8.6 2.7 12.8.1.2.1.5.1.7-.1.6-.6 1-1.1 1-.2 0-.3-.1-.5-.2-1-.6-1.9-1.1-2.9-1.7-2.9-1.7-5.8-3.3-8.6-5-.1-.1-.3-.1-.4 0-3.6 2.1-7.2 4.2-10.7 6.3-.3.2-.5.3-.8.5-.5.3-1.1.1-1.4-.3-.1-.2-.2-.5-.1-.8.4-2.1.9-4.3 1.3-6.4.5-2.3.9-4.5 1.4-6.8 0-.1 0-.3-.1-.4-2.3-2-4.5-4.1-6.8-6.1-1-.9-2.1-1.9-3.1-2.8-.4-.3-.5-.7-.4-1.2.1-.4.5-.7 1-.8 1.7-.2 3.3-.4 5-.5 2-.2 3.9-.4 5.9-.7.7-.1 1.5-.2 2.3-.2.2 0 .3-.1.4-.3 1.8-4 3.5-8.1 5.3-12.1 0-.3.4-.6.9-.6z"
                    />
                </g>
            </svg>
            <svg
                class="text-yellow-400 absolute transform z-negative"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 41.9 40.3"
            >
                <g>
                    <path
                        fill="currentColor"
                        d="M20.9 0c.5 0 .9.3 1 .7 1.6 3.6 3.2 7.2 4.8 10.7.2.5.4.9.6 1.4 0 .1.2.2.3.2 2.3.2 4.6.5 6.9.7 2.1.2 4.3.5 6.4.7.4 0 .8.3.9.7.1.4 0 .9-.3 1.1-.9.8-1.8 1.7-2.7 2.5l-7.2 6.6c-.1.1-.1.2-.1.3.9 4.3 1.8 8.6 2.7 12.8.1.2.1.5.1.7-.1.6-.6 1-1.1 1-.2 0-.3-.1-.5-.2-1-.6-1.9-1.1-2.9-1.7-2.9-1.7-5.8-3.3-8.6-5-.1-.1-.3-.1-.4 0-3.6 2.1-7.2 4.2-10.7 6.3-.3.2-.5.3-.8.5-.5.3-1.1.1-1.4-.3-.1-.2-.2-.5-.1-.8.4-2.1.9-4.3 1.3-6.4.5-2.3.9-4.5 1.4-6.8 0-.1 0-.3-.1-.4-2.3-2-4.5-4.1-6.8-6.1-1-.9-2.1-1.9-3.1-2.8-.4-.3-.5-.7-.4-1.2.1-.4.5-.7 1-.8 1.7-.2 3.3-.4 5-.5 2-.2 3.9-.4 5.9-.7.7-.1 1.5-.2 2.3-.2.2 0 .3-.1.4-.3 1.8-4 3.5-8.1 5.3-12.1 0-.3.4-.6.9-.6z"
                    />
                </g>
            </svg>
            <svg
                class="text-yellow-400 absolute transform z-negative"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 41.9 40.3"
            >
                <g>
                    <path
                        fill="currentColor"
                        d="M20.9 0c.5 0 .9.3 1 .7 1.6 3.6 3.2 7.2 4.8 10.7.2.5.4.9.6 1.4 0 .1.2.2.3.2 2.3.2 4.6.5 6.9.7 2.1.2 4.3.5 6.4.7.4 0 .8.3.9.7.1.4 0 .9-.3 1.1-.9.8-1.8 1.7-2.7 2.5l-7.2 6.6c-.1.1-.1.2-.1.3.9 4.3 1.8 8.6 2.7 12.8.1.2.1.5.1.7-.1.6-.6 1-1.1 1-.2 0-.3-.1-.5-.2-1-.6-1.9-1.1-2.9-1.7-2.9-1.7-5.8-3.3-8.6-5-.1-.1-.3-.1-.4 0-3.6 2.1-7.2 4.2-10.7 6.3-.3.2-.5.3-.8.5-.5.3-1.1.1-1.4-.3-.1-.2-.2-.5-.1-.8.4-2.1.9-4.3 1.3-6.4.5-2.3.9-4.5 1.4-6.8 0-.1 0-.3-.1-.4-2.3-2-4.5-4.1-6.8-6.1-1-.9-2.1-1.9-3.1-2.8-.4-.3-.5-.7-.4-1.2.1-.4.5-.7 1-.8 1.7-.2 3.3-.4 5-.5 2-.2 3.9-.4 5.9-.7.7-.1 1.5-.2 2.3-.2.2 0 .3-.1.4-.3 1.8-4 3.5-8.1 5.3-12.1 0-.3.4-.6.9-.6z"
                    />
                </g>
            </svg>
        </div>
    </div>
</template>
<script>
export default {
    props: ['plan', 'section', 'isSelected'],

    computed: {
        buttonText() {
            return 'Elegir ' + this.plan.presentable_name;
        },
    },

    methods: {
        getColor() {
            return this.plan.id === 'anual' ? 'red' : 'blue';
        },

        choose() {
            this.$emit('planWasSelected', this.plan);
        },
    },
};
</script>
